<div class="loading-component">
  <div class="dot one">.</div>
  <div class="dot two">.</div>
  <div class="dot three">.</div>
</div>
